import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import classNames from "classnames";
import { STATIC_STRINGS } from "@asez/shared";

const RenderError = ({
  onRetry,
  error,
}: {
  onRetry?: () => void;
  error?: any;
}) => {
  return (
    <div className={classNames("report-container")}>
      <div className="card text-center  w-full h-full flex items-center justify-center">
        <div>
          <ErrorOutlineIcon color="error" fontSize="large" />
          <h2 className="text-lg font-semibold text-red-600 mt-2">
            {STATIC_STRINGS.ERROR_MESSAGE}
          </h2>
          <p className="text-gray-600 mt-1">
            {STATIC_STRINGS.SETTINGS_API_ERROR}
          </p>
          <button onClick={onRetry} className="btn btn-outline mt-2">
            {STATIC_STRINGS.RETRY}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RenderError;
